import { render } from "./mail-icon.svg?vue&type=template&id=02dd5408"
import script from "./mail-icon.svg?vue&type=script&lang=js"
export * from "./mail-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1567/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__